module.exports = __webpack_public_path__ + "img/chpc_about_01.e02973ef.png";